import React from 'react'
import { IconComponent, JumpHotAreaComponent, NumberComponent, NumberComponentWithRect, PictureProgress, PointerProgressComponent, ProgressComponent } from '../../components'

const componentMap = (hasRectArea) => ({
  text: hasRectArea ? NumberComponentWithRect : NumberComponent,
  icon: IconComponent,
  pointer_progress: PointerProgressComponent,
  progress: ProgressComponent,
  image_progress: PictureProgress,
  jumpable: JumpHotAreaComponent
})

class Stand extends React.Component {
  static renderLayer = ({ childKey, hasRectArea, ...restArgs }) => {
    const Component = componentMap(hasRectArea)[childKey]
    if (Component && Component.renderLayer) {
      Component.renderLayer({ childKey, ...restArgs })
    }
  }

  static removeLayer = ({ childKey, hasRectArea, ...restArgs }) => {
    const Component = componentMap(hasRectArea)[childKey]

    if (Component && Component.removeLayer) {
      Component.removeLayer({ childKey, ...restArgs })
    }
  }

  render() {
    const { childKey, propMap } = this.props
    const prop = propMap[childKey] || {}
    const { hasRectArea } = prop
    const Component = componentMap(hasRectArea)[childKey]
    const allProps = { ...this.props, ...prop }

    if (childKey === 'image_progress') {
      return <PictureProgress {...allProps} />
    }
    return <div className="control-container">{Component && <Component {...allProps} />}</div>
  }
}

export default Stand
